var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup417(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#f4f7f2}.cls-3{fill:#486a41}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    transform: "translate(-1354 -81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_651",
    fill: "none",
    d: "M0 0H300V300H0z",
    transform: "translate(1354 81)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    cx: 81.456,
    cy: 81.456,
    r: 81.456,
    className: "cls-2",
    transform: "translate(1361.323 149.544)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    cx: 40.199,
    cy: 40.199,
    r: 40.199,
    className: "cls-2",
    transform: "translate(1540.102 149.544)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_001-import",
    transform: "translate(1450.184 173.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    d: "M46.6 82.2a35.6 35.6 0 1 1 35.6-35.6 35.64 35.64 0 0 1-35.6 35.6zm0-65.72A30.122 30.122 0 1 0 76.72 46.6 30.161 30.161 0 0 0 46.6 16.477z",
    className: "cls-3",
    transform: "translate(49.244 49.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    d: "M33.17 38.9a2.75 2.75 0 0 1-1.939-.8L14.8 21.674a2.738 2.738 0 1 1 3.873-3.874l14.491 14.493L47.655 17.8a2.738 2.738 0 0 1 3.872 3.872L35.1 38.1a2.707 2.707 0 0 1-1.928.8z",
    className: "cls-3",
    transform: "translate(62.672 76.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    d: "M19.738 50.968A2.739 2.739 0 0 1 17 48.229V16.738a2.738 2.738 0 0 1 5.477 0v31.491a2.739 2.739 0 0 1-2.739 2.739z",
    className: "cls-3",
    transform: "translate(76.104 62.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    d: "M54.767 43.812a2.811 2.811 0 0 1-.947-.17L1.791 24.474a2.737 2.737 0 0 1 0-5.137L53.819.169a2.749 2.749 0 0 1 1.895 0l52.029 19.168a2.737 2.737 0 0 1 0 5.137L55.714 43.643a2.81 2.81 0 0 1-.947.169zM10.658 21.906l44.109 16.249 44.109-16.249-44.109-16.25z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    d: "M47.209 91.072a2.726 2.726 0 0 1-.947-.17L1.791 74.527A2.741 2.741 0 0 1 0 71.959V6.238a2.738 2.738 0 0 1 5.477 0v63.809l42.68 15.718a2.738 2.738 0 0 1-.947 5.307z",
    className: "cls-3",
    transform: "translate(0 15.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    d: "M21.738 33.622A2.739 2.739 0 0 1 19 30.883V6.238a2.738 2.738 0 0 1 5.477 0v24.645a2.739 2.739 0 0 1-2.739 2.739z",
    className: "cls-3",
    transform: "translate(85.057 15.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    d: "M12.238 40.024A2.739 2.739 0 0 1 9.5 37.286V9.738a2.738 2.738 0 1 1 5.477 0v27.548a2.736 2.736 0 0 1-2.739 2.738z",
    className: "cls-3",
    transform: "translate(42.529 31.335)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup417);
export default __webpack_public_path__ + "static/media/Group 417.3bb0240d94728ff79154de5b166bb906.svg";
export { ForwardRef as ReactComponent };